import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  countOpenForStation,
  createIssue,
  listForStation,
  listMine,
  type IssueCreateInput,
} from "./api";

export function useOpenIssuesCount(stationId: string | undefined) {
  return useQuery({
    queryKey: ["issues", "station", stationId ?? "", "count"],
    queryFn: () => countOpenForStation(stationId!),
    enabled: !!stationId,
    staleTime: 60_000,
  });
}

export function useStationIssues(stationId: string | undefined) {
  return useQuery({
    queryKey: ["issues", "station", stationId ?? "", "list"],
    queryFn: () => listForStation(stationId!),
    enabled: !!stationId,
    staleTime: 60_000,
  });
}

export function useMyIssues() {
  return useQuery({
    queryKey: ["issues", "mine"],
    queryFn: listMine,
    staleTime: 60_000,
  });
}

export function useCreateIssue(stationId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: IssueCreateInput) => createIssue(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["issues", "station", stationId] });
      qc.invalidateQueries({ queryKey: ["issues", "mine"] });
    },
  });
}
